/**
 *
 * key
 *
 */

const key = 'Zm9sbG93dXA'

export default key
